export enum SocketEvent {
	UpdatedNft = "updated_nft",
	UpdatedOffers = "updated_offers",
	UpdatedAuction = "updated_auction",
	UpdatedUser = "updated_user",
}
